module.exports = __webpack_public_path__ + "img/92137.f09bb0bb.svg";